import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';

// オンボーディングツアーの完了フラグ。テーマ等と同方針でブラウザ単位・localStorage 永続。
// 一度完了/スキップすると初回自動表示はしない（ヘルプからの再生は可能）。
export const onboardingDoneAtom = atomWithStorage<boolean>(
    'onboardingDone',
    false,
    undefined,
    { getOnInit: true },
);

// ツアーの開閉状態（永続しない一時 state）。初回自動表示・ヘルプからの再生で共有する。
export const onboardingOpenAtom = atom<boolean>(false);
